export default {"src":"/_next/static/media/switchCamera.20b02026.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};